import WebServiceRequest from "../../Api/WebServiceRequest";

class GuildGetAll extends WebServiceRequest {
  constructor(context) {
    super(context);
  }
  setParams(data) {
    super.setTag(
      "Guild/GetAll?pageNumber=" + data.pageNumber + "&count=" + data.count
    );
  }
}
export default GuildGetAll;
